import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../App'
import { ReactComponent as WreckIco } from '../../assets/svg/ico_boat.svg'
import { ReactComponent as UnderwaterIco } from '../../assets/svg/ico_underwater.svg'
import { ReactComponent as OtherIco } from '../../assets/svg/ico_amphora.svg'
import { ReactComponent as MuseumIco } from '../../assets/svg/ico_museum.svg'
import CollapsibleList from '../components/collapsibleList';
import { COLORS } from '../../config';

const CategorySelector = () => {
  const { mapFeatures, setFeature, getTranslatedUiLabel, searchKeyword } = useContext(AppContext)
  const [categories, setCategories] = useState({})

  useEffect(() => {
    const featuresByCategory = mapFeatures && mapFeatures.reduce((acc, feature) => {
      let {type} = feature;
      return {...acc, [type]: (acc[type] ? [].concat(acc[type], [feature]) : ([feature])) }
    }, {})

    setCategories(featuresByCategory)
  }, [mapFeatures])

  return (
    <div className={`App-category-selector ${!searchKeyword && "hide-mobile"}`}>
      { categories && categories.underwaterStructure && <CollapsibleList items={categories.underwaterStructure} label={getTranslatedUiLabel(3)} icon={UnderwaterIco} itemAction={setFeature} color={COLORS.BLUE} isOpen={!!searchKeyword}/> }
      { categories && categories.wreck && <CollapsibleList items={categories.wreck} label={getTranslatedUiLabel(2)} icon={WreckIco} itemAction={setFeature} color={COLORS.GREEN} isOpen={!!searchKeyword}/> }
      { categories && categories.other && <CollapsibleList items={categories.other} label={getTranslatedUiLabel(5)} icon={OtherIco} itemAction={setFeature} color={COLORS.YELLOW} isOpen={!!searchKeyword}/> }
      { categories && categories.museum && <CollapsibleList items={categories.museum} label={getTranslatedUiLabel(4)} icon={MuseumIco} itemAction={setFeature} color={COLORS.ORANGE} isOpen={!!searchKeyword}/> }
    </div>
  )
};

export default CategorySelector;